<div class="weissman-picklist">

    <ws-select [options]="availableOptions"
               [labelProperty]="labelProperty"
               [returnEntireOption]="true"
               [placeholder]="placeholder"
               [formControl]="listSelection">
    </ws-select>

    <div class="picklist-container"
         [@picklistVisible]="picklist.length ? 'show' : 'hide'"
         clickOutside
         (clickOutside)="unsetSelected()">
        <ul class="picklist" [class.open]="animationComplete">
            @for (option of picklist; track $index; let i = $index; let last = $last) {
                <li (click)="setSelected(option, i)"
                    [attr.data-qa]="'picklist-item-' + i"
                    [class.clickable]="canReorganize"
                    [class.selected]="option === selectedOption && canReorganize">
                    <div class="list-label">
                        <span>{{ option[labelProperty] }}</span>
                        @if (canRemove && !canReorganize && !(mustHaveOne && picklist.length === 1)) {
                            <i class="fa fa-times remove"
                               [attr.data-qa]="'picklist-remove-item-' + i"
                               (click)="removeOption(option)">
                            </i>
                        }
                    </div>
                </li>
            }
        </ul>

        @if (canReorganize) {
            <div class="picklist-controls">
                <button class="direction picklist-up"
                        data-qa="picklist-up"
                        (click)="shiftOptionUp()"
                        [disabled]="!selectedOption || selectedOptionIndex === 0">
                    <i class="fa fa-arrow-up"></i>
                </button>
                @if (canRemove) {
                    <button
                        class="remove"
                        data-qa="picklist-remove"
                        (click)="removeOption()"
                        [disabled]="!selectedOption || (mustHaveOne && picklist.length === 1)">
                        <i class="fa fa-times"></i>
                    </button>
                }
                <button class="direction picklist-down"
                        data-qa="picklist-down"
                        (click)="shiftOptionDown()"
                        [disabled]="!selectedOption || selectedOptionIndex === (picklist.length - 1)">
                    <i class="fa fa-arrow-down"></i>
                </button>
            </div>
        }

    </div>
</div>
